/* eslint-disable import/no-unresolved */
import { memo } from "react";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import DetailsHeading from "src/shared/DetailsHeading";
import CustomStepper from "src/shared/CustomStepper";
import { showNewVersionUW } from "src/helpers/FormDetails/ProposalDetails/resources";
import JointLifeMember from "./JointLifeGeneralDetails";
import JointLifeCovidAndNri from "./JointLifeCovidAndNri";
import JointMedicalLifeStyleV2 from "./JointMedicalLifeStyleV2";
import JointLifeMedicalLifestyle from "./JointLifeMedicalLifestyle";

function JoinLife() {
  const nationality = useAppSelector((state) => state.jointLifeAddendum?.member?.nationalityCode);
  const jointMembersData = useAppSelector((state) => state?.common?.leadDetails?.Members)?.filter(
    (e: any) => e?.isJointMember
  )[0];
  const steps = [
    "General Details",
    "Medical & Lifestyle",
    ...(!["RES", ""].includes(nationality!) ? ["NRI Details"] : [])
  ];
  // const [stepNo, setStepNo] = useState(1);
  const jointStepNumber = useAppSelector((state) => state.stepDetails.jointStepNo);

  const compType = () => {
    switch (jointStepNumber) {
      case 1:
        return <JointLifeMember />;
      case 2:
        return showNewVersionUW(jointMembersData) ? (
          <JointMedicalLifeStyleV2 />
        ) : (
          <JointLifeMedicalLifestyle />
        );
      case 3:
        return nationality !== "RES" ? <JointLifeCovidAndNri /> : <>default</>;
      default:
        return <>default</>;
    }
  };
  return (
    <div className="bg-whiteSmoke pt-8 pb-19.5 ">
      {/* <div className="w-290 bg-white pt-8.5 pb-10 mx-auto rounded-1.5xl"> */}
      <div className="xl:w-290 bg-white pt-8.5 pb-10 mx-auto rounded-1.5xl">
        <div className="pr-10 pl-10.25">
          <DetailsHeading label="Joint Life Details" />
        </div>
        <CustomStepper
          steps={steps}
          currentStep={jointStepNumber}
          stepperValue="joint"
          // setStepNo={setStepNo}
          showBackArrow={false}
          leftSpacingClasses="w-8/100"
          rightSpacingClasses="w-68/1000"
          circleSizeClasses="h-6 w-6"
        />
        <div>{compType()}</div>
      </div>
    </div>
  );
}

export default memo(JoinLife);
